import {
  Box,
  Flex,
  FlexProps,
  HStack,
  Image,
  Link,
  Text,
  VStack,
  useColorModeValue,
  SimpleGrid,
} from '@chakra-ui/react';

import React from 'react';
import { Company } from '~/generated/graphql';

const CompanySection: React.FC<
  FlexProps & {
    company: Company;
  }
> = ({ company }) => {
  const { logo, industry, name, homepage, headquartersAddress } = company;

  return (
    <Flex bg={useColorModeValue('white', 'gray.800')} mt="0px">
      <VStack mt="0px">
        <HStack
          mt="0px"
          justifyContent="space-between"
          bg={useColorModeValue('white', 'gray.800')}
        >
          <Image
            fit="cover"
            objectPosition="center"
            src={logo || undefined}
            alt={`${name}のロゴ`}
            maxWidth="128px"
          />
          <SimpleGrid columns={{ sm: 1, md: 2 }} spacing="20px">
            <Box>
              <Text>会社名: {name}</Text>
            </Box>
            <Box>
              <Text>業種: {industry}</Text>
            </Box>
            <Box>
              <Text>本社所在地: {headquartersAddress}</Text>
            </Box>
            {homepage && (
              <Box>
                ウェブサイト:
                <Link px={2} href={homepage} target="_blank">
                  {homepage.replace(/^http[s]:\/\//, '')}
                </Link>
              </Box>
            )}
          </SimpleGrid>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default CompanySection;
